import React from 'react';
import { Grid, Divider, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NCRFormHeading from '../NCRFormHeading';
import dayjs from 'dayjs';
import NCRFormLabel from '../NCRFormLabel';
import AILabelBox from '../AILabelBox';
import { handleAIClick } from '../../../Helpers/NCRHelpers';
import NCRMultilineTextfields from '../NCRMultilineTextfields';

export default function PreventiveActions({ content, onChange, onAiResponseChange }) {

  const theme = createTheme({
    components: {
      MuiSelect: {
        styleOverrides: {
          select: {
            fontSize: "14px",
            fontWeight: 400,
            color: "rgba(84, 84, 84, 1)",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: 400,
              color: "rgba(84, 84, 84, 1)",
              opacity: 1,
            },
          },
        },
      },
    },
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const handleTimelineChange = (newValue) => {
    if (!dayjs(newValue).isValid()) {
      console.warn("Invalid date selected:", newValue);
      return;
    }
    onChange({
      ...content.formData,
      preventive_action_implementation_timeline: newValue ? newValue.toISOString() : null,
    });
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Box sx={{ p: 3 }}>
            <Box>
              <NCRFormHeading isRequired={true} tooltipData={
                [
                  { title: "Preventive Action Plan", description: "Provide a detailed plan of preventive measures to ensure long-term elimination of the issue." },
                  { title: "Implementation Timeline", description: "Set the expected implementation date for each preventive action." },
                ]
              }>
                Preventive Actions
              </NCRFormHeading>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: '50%', mr: 4 }}>
                <Grid item xs={4}>
                  <NCRFormLabel sx={{ mb: 1 }}>
                    Preventive Action Plan:
                  </NCRFormLabel>
                </Grid>
                <Grid item xs={8}>
                  <NCRMultilineTextfields
                    name="preventive_action_plan"
                    value={content.formData.preventive_action_plan || ""}
                    onChange={handleInputChange}
                    disabled={content.inputDisable}
                    error={!!content?.errors?.preventive_action_plan}
                    placeholder={!content.inputDisable ? 'Enter corrective actions for process root cause' : 'No data entered'}
                  />
                </Grid>
              </Box>
              {!content?.inputDisable && content?.label !== 'edit' &&
                <AILabelBox
                  label="preventive_action_plan"
                  handleAIClick={(fieldName) => handleAIClick(fieldName, content, onAiResponseChange)}
                  aiResponse={content.aiResponse || {}}
                  onChange={onChange}
                />
              }
            </Box>
            <Box sx={{ flexGrow: 1, mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={6}>
                        <NCRFormLabel>
                          Implementation Timeline:
                        </NCRFormLabel>
                      </Grid>
                      <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            name="preventive_action_implementation_timeline"
                            disabled={content.inputDisable}
                            format="DD/MM/YYYY"
                            // minDate={dayjs()}
                            // maxDate={dayjs()}
                            onChange={handleTimelineChange}
                            value={
                              content.formData.preventive_action_implementation_timeline
                                ? dayjs(content.formData.preventive_action_implementation_timeline)
                                : null
                            }
                            renderInput={(params) => <TextField {...params} />}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "42px",
                                width: "190px",
                                fontSize: "14px",
                                border: !!content?.errors?.preventive_action_implementation_timeline
                                  ? "1px solid red"
                                  : "1px solid rgba(0, 0, 0, 0.23)",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: "18px",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Divider sx={{ mb: 1 }} />
        </Box>
      </ThemeProvider >
    </>
  );
};
